import { useCallback } from 'react';

import { useCustomerActions, usePerformanceActions } from 'src/store';
import { useCipEvents } from 'src/services';
import { useErrorHandler } from 'src/hooks';
import { CONNECT_WEBSITE_ACCOUNTS_POPUP } from '../types';
import { usePopups } from '../services';

export const useConnectWebsiteAccountsPopup = () => {
  const popups = usePopups();
  const customerActions = useCustomerActions();
  const performanceActions = usePerformanceActions();
  const cipEvents = useCipEvents();
  const handleError = useErrorHandler();

  const refreshCustomerFeatureLimit = useCallback(() => {
    customerActions.refreshCurrentCustomerFeatureLimit();
  }, [customerActions]);

  return useCallback(
    (channel) => {
      return new Promise((resolve) => {
        popups.openPopup(CONNECT_WEBSITE_ACCOUNTS_POPUP, {
          channel,
          onClose: () => {
            resolve();
            popups.closePopup(CONNECT_WEBSITE_ACCOUNTS_POPUP);
          },
          onSubmit: async ({ urls, channel }) => {
            try {
              await performanceActions.createWebsiteAccount(
                urls,
                channel,
                refreshCustomerFeatureLimit
              );

              resolve({ channel, urls });
              popups.closePopup(CONNECT_WEBSITE_ACCOUNTS_POPUP);
              cipEvents.trackConnectWebsiteAccounts(channel, urls);
            } catch (error) {
              performanceActions.setExtractingCopies(channel, false);
              handleError(error);
            }
          },
          onDisconnect: async (channel) => {
            resolve();
            await performanceActions.updateConnectedAccounts({ channel, selectedAccountIds: [] });
            await refreshCustomerFeatureLimit();
            popups.closePopup(CONNECT_WEBSITE_ACCOUNTS_POPUP);
          },
        });
      });
    },
    [performanceActions, popups, refreshCustomerFeatureLimit, cipEvents, handleError]
  );
};
